import { render, staticRenderFns } from "./TimerWidget.vue?vue&type=template&id=089934c6&"
import script from "./TimerWidget.vue?vue&type=script&lang=js&"
export * from "./TimerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports